import { render, staticRenderFns } from "./SliderModule.vue?vue&type=template&id=44ce809f&"
import script from "./SliderModule.vue?vue&type=script&lang=js&"
export * from "./SliderModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports